const REFERRAL_SUBMISSION_FLAG_PREFIX = 'referral_just_submitted_';

function markReferralJustSubmitted(rfid: string): void {
  try {
    sessionStorage.setItem(`${REFERRAL_SUBMISSION_FLAG_PREFIX}${rfid}`, 'true');
  } catch {
    // quota exceeded or unavailable in private browsing — fail silently
  }
}

function wasReferralJustSubmitted(rfid: string): boolean {
  try {
    return (
      sessionStorage.getItem(`${REFERRAL_SUBMISSION_FLAG_PREFIX}${rfid}`) ===
      'true'
    );
  } catch {
    return false;
  }
}

function clearReferralJustSubmittedFlag(rfid: string): void {
  try {
    sessionStorage.removeItem(`${REFERRAL_SUBMISSION_FLAG_PREFIX}${rfid}`);
  } catch {
    // ignore
  }
}

export {
  markReferralJustSubmitted,
  wasReferralJustSubmitted,
  clearReferralJustSubmittedFlag
};
